import { Component, HostListener, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { displayPayLink, verifyLink, removeIFrame, initializaVerifyLink } from '../../assets/dollarpay.js'

import { Router, ActivatedRoute } from '@angular/router';


import { HttpService } from '../services/httpService';

@Component({
  selector: 'app-deposit-verify-component',
  templateUrl: './deposit-verify.component.html'
})
export class DepositVerifyComponent {
  public currentCount = 0;

  public incrementCounter() {
    this.currentCount++;
  }

  source;
  loading: boolean = false;
  RoutingNumber = "";
  AccountNumber = "";
  paymentAlreadyDone: boolean = false;

  constructor(public router: Router, private activeRoute: ActivatedRoute, private httpService: HttpService
  ) {

    this.source = decodeURI(this.activeRoute.snapshot.params['id']);

    this.fetchDetails();

    initializaVerifyLink(this.source);

  }
  vendor;


  fetchDetails() {

    this.loading = true;
    const request = {
      Id: this.source
    }



    this.httpService.post<any>('Store/fetch-dwolla-customer-id-details', request, false).subscribe(
      resp => {
        this.vendor = JSON.parse(resp.message);

        if (this.vendor.bankAccountVerified == 1) {

          this.paymentAlreadyDone = true;

        }

        if (this.vendor.microDepositSent == 1) {

          this.router.navigate(['/verify-micro-deposits', this.source]);

        }

        this.loading = false;

      },
      error => {
        this.loading = false;

        //this.snackbarService.show('Oh no! That email or password was incorrect.');
      });


  }

  error: boolean = false;
  sent: boolean = false;
  approve: boolean = false;

  show() {

    if (this.RoutingNumber.length == 9 || this.AccountNumber.length > 5) {


      this.loading = true;

      const request = {
        DwollaCustomerId: this.source,
        RoutingNumber: this.RoutingNumber,
        AccountNumber: this.AccountNumber,
        BusinessName: this.vendor.name,
      }

      this.httpService.post<any>('Store/create-business-funding-source-and-send-deposits', request, false).subscribe(
        resp => {
          this.vendor = JSON.parse(resp.message);

          if (JSON.parse(resp.message).message == 'success') {
            this.sent = true;
            //window.scroll(0, 0);

          }

          this.loading = false;

        },
        error => {
          this.loading = false;

          //this.snackbarService.show('Oh no! That email or password was incorrect.');
        });



    }

    //verifyLink(this.source);

    else {


      this.error = true;


    }
  }


  success: boolean = false;
  start: boolean = true;
  transactionId;

  @HostListener('window:message', ['$event'])
  onMessage(event) {

    console.log(event)
    const data = JSON.parse(event.data);
    //console.log(data.message)

    if (data.message == 'success') {

      //this.transactionId = data.transactionId;
      removeIFrame();

      this.start = false;
      this.success = true;


    }



    if (data.message == 'terminated') {
      console.log("termination")
      removeIFrame();


    }

  };


}
